import React, { useState, useCallback } from 'react'

type ErrorType = { [index: string]: any } | undefined

export const ErrorContext = React.createContext<{
  error: ErrorType,
  setError(error: ErrorType): void,
}>({
  error: {},
  setError: (error: ErrorType) => {},
})

export default function ErrorProvider({ children }: { children: any }) {
  const [error, setError] = useState<ErrorType>()

  const contextValue = {
    error,
    setError: useCallback((error: ErrorType) => {
      setError(error)
    }, []),
  }

  return (
    <ErrorContext.Provider value={contextValue}>
      {children}
    </ErrorContext.Provider>
  )
}